"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformQuantityOrderedToDataTable = void 0;
var transformQuantityOrderedToDataTable = function transformQuantityOrderedToDataTable(order) {
  return {
    cells: [{
      value: order.deliveryDate,
      className: 'cds-StockCountTable-Date'
    }, {
      value: order.quantityOrdered,
      className: 'cds-StockCountTable-Amount'
    }]
  };
};
exports.transformQuantityOrderedToDataTable = transformQuantityOrderedToDataTable;